
import { computed, defineComponent } from "vue";
import { useNotification } from "./notify";

export default defineComponent({
  props: {},
  setup(props, context) {
    const { notification, closeNotification, open } = useNotification();

    const text = computed(
      () => notification.value?.text || "missing notification text"
    );

    return {
      notification,
      closeNotification,
      open,
      text,
    };
  },
});
